import { SORT_DIRECTIONS } from 'constants/sortDirectionsEnum';
import { EXPERIMENTS_TABLE_COLUMNS, TableSortContextState } from 'modules/experiments/types';
import { createContext, useContext } from 'react';
import noop from 'utils/noop';

export const initialTableSortContextState: TableSortContextState = {
  sortBy: EXPERIMENTS_TABLE_COLUMNS.LAST_MODIFIED,
  setSortBy: noop,
  sortDirection: SORT_DIRECTIONS.DESCENDING,
  setSortDirection: noop,
};

export const TableSortContext = createContext(initialTableSortContextState);

export const useTableSortContext = () => useContext(TableSortContext);
